<template>
  <div>
    <VSelect
      id="group-selector"
      v-model="groupSelected"
      outlined
      dense
      return-object
      :menu-props="{ botton: true, offsetY: true }"
      :items="groupList"
      item-text="title"
      :label="'Selecione o grupo'"
      @change="onChange"
    />
  </div>
</template>

<script>
export default {
  name: 'GroupSelector',
  props: {
    groupActive: {
      type: String,
      default: '',
    },
    componentName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      groupSelected: '',
    };
  },
  computed: {
    groupList() {
      return this.$store.state.ui.groupList;
    },
  },
  mounted() {
    const groupSelected = this.groupList.find(group => group.id === this.groupActive);

    this.groupSelected = groupSelected ?? this.groupList[0];
  },
  methods: {
    changeGroup(group) {
      this.$store.dispatch(`charts/add${this.componentName}Group`, group);
    },
    async onChange(params) {
      this.changeGroup(params.id);
      this.$emit('onGroupChange', { ...params });
    },
  },
};
</script>
